var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.href ? 'a' : 'button',{tag:"component",class:[
        'button',
        { filled: _vm.color === 'filled' },
        { empty: _vm.color === 'empty' },
        { blue: _vm.color === 'blue' },
    ],attrs:{"href":_vm.href},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("prepend"),_vm._v(" "),_c('span',{staticClass:"button-center"},[_c('span',{staticClass:"text"},[_vm._t("default")],2),_vm._v(" "),(_vm.color === 'empty')?_c('span',{staticClass:"text-original"},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.color === 'empty')?_c('span',{staticClass:"text-hover"},[_vm._t("default")],2):_vm._e()]),_vm._v(" "),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }